'use client';

import * as React from 'react';
import { useHasMounted } from 'hooks/use-has-mounted';

export interface FormattedDateProps {
  date: Date | string;
}

export function FormattedDate(props: FormattedDateProps): JSX.Element | string {
  const hastMounted = useHasMounted();
  if (!hastMounted) {
    return '';
  }
  const d = new Date(props.date);
  return <>{d.toLocaleDateString(navigator.language)}</>;
}
